module.exports = __webpack_public_path__ + "static/media/chart_inactive.8c549fa1.svg";